/*
 *
 * Package: `@dbh/collapsible-redux-form-section-theme`.
 *
 */const THEME_KEY_COLLAPSIBLE_REDUX_FORM_SECTION="collapsibleReduxFormSection";const modifyCollapsibleReduxFormSectionTheme=a=>{let{colors:{transparent:b},spacing:{sp3:c,sp5:d}}=a;return {[THEME_KEY_COLLAPSIBLE_REDUX_FORM_SECTION]:{collapsibleArea:{backgroundColor:b,padding:c+" 0 "+d}}}};

export { THEME_KEY_COLLAPSIBLE_REDUX_FORM_SECTION, modifyCollapsibleReduxFormSectionTheme as default };
